/**
* 头部菜单
*/ 
<template>
	<div>
		<el-menu class="el-menu-demo" mode="horizontal" background-color="#334157" text-color="#fff" active-text-color="#fff">
			<el-button class="buttonimg">
				<img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
			</el-button>
			<el-submenu index="2" class="submenu">
				<template slot="title">{{user.nickName}}</template>
				<el-menu-item index="2-1" @click="centerDialogVisible = true">修改密码</el-menu-item>
				<!-- <el-menu-item @click="content()" index="2-2">个人中心</el-menu-item> -->
				<el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
			</el-submenu>
		</el-menu>

		<el-dialog title="修改密码"  :visible.sync="centerDialogVisible" width="30%" center>
			<el-form ref="pass" :rules="rules" :model="pass" label-width="80px">
				<el-form-item label="旧密码" prop="oldPwd">
					<el-input v-model="pass.oldPwd" placeholder="输入旧密码"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPwd">
					<el-input v-model="pass.newPwd" placeholder="输入新密码"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPwdAg">
					<el-input v-model="pass.newPwdAg" placeholder="再次输入新密码"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogClose('pass')">取 消</el-button>
				<el-button type="primary" @click="updatePwd('pass')">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>
<script>
import { loginout, updatePwd } from '../api/userMG';
export default {
	name: 'navcon',
	data() {
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.pass.newPwd) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			pass: {
				oldPwd: '',
				newPwd: '',
				newPwdAg: '',
			},
			rules: {
				oldPwd: [
					{
						required: true,
						message: '请输入旧密码',
						trigger: 'blur',
					},
					{
						min: 3,
						max: 10,
						message: '长度在 3 到 10 个字符',
						trigger: 'blur',
					},
				],
				newPwd: [
					{
						required: true,
						message: '请输入新密码',
						trigger: 'blur',
					},
					{
						min: 3,
						max: 10,
						message: '长度在 3 到 10 个字符',
						trigger: 'blur',
					},
				],
				newPwdAg: [
					{ validator: validatePass2, trigger: 'blur' },
					{
						required: true,
						message: '请再次输入新密码',
						trigger: 'blur',
					},
				],
			},
			centerDialogVisible: false,
			collapsed: true,
			imgshow: require('../assets/img/show.png'),
			imgsq: require('../assets/img/sq.png'),
			user: {},
		};
	},
	// 创建完毕状态(里面是操作)
	created() {
		this.user = JSON.parse(localStorage.getItem('userdata'));
	},
	methods: {
		dialogClose(formName) {
			this.$refs[formName].resetFields();
			this.centerDialogVisible = false;
		},
		updatePwd(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$confirm('修改密码, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					})
						.then(() => {
							updatePwd(this.pass).then((res) => {
								if (res) {
									this.$message({
										type: 'success',
										message: '修改成功!',
									});
									this.$store.commit('logout', 'false');
									this.$router.push({ path: '/login' });
								}
							});
						})
						.catch(() => {
							this.$message({
								type: 'info',
								message: '已取消',
							});
						});
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 退出登录
		exit() {
			this.$confirm('退出登录, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					loginout().then((res) => {
						if (res) {
							//如果请求成功就让他2秒跳转路由
							setTimeout(() => {
								this.$store.commit('logout', 'false');
								this.$router.push({ path: '/login' });
								this.$message({
									type: 'success',
									message: '已退出登录!',
								});
							}, 1000);
						}
					});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消',
					});
				});
		},
		// 切换显示
		toggle(showtype) {
			this.collapsed = !showtype;
			this.$root.Bus.$emit('toggle', this.collapsed);
		},
	},
};
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
	border: none;
}
.submenu {
	float: right;
}
.buttonimg {
	height: 60px;
	background-color: transparent;
	border: none;
}
.showimg {
	width: 26px;
	height: 26px;
	position: absolute;
	top: 17px;
	left: 17px;
}
.showimg:active {
	border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue